export enum WidgetId {
  ActivateProfile = 'widget-ActivateProfile',
  ApproveEmail = 'widget-ApproveEmail',
  Auth = 'widget-Auth',
  Breadcrumbs = 'widget-Breadcrumbs',
  ChangePassword = 'widget-ChangePassword',
  CopyableText = 'widget-CopyableText',
  DownloadMessage = 'widget-DownloadMessage',
  ErrorUnknown = 'widget-ErrorUnknown',
  Footer = 'widget-Footer',
  GameContent = 'widget-GameContent',
  GlobalStatic = 'widget-GlobalStatic',
  LangSwitcher = 'widget-LangSwitcher',
  LoggedOutWindow = 'widget-LoggedOutWindow',
  NavigationMenu = 'widget-NavigationMenu',
  PageNotFound = 'widget-PageNotFound',
  PlariumGamesPromo = 'widget-PlariumGamesPromo',
  Profile = 'widget-Profile',
  Promocodes = 'widget-Promocodes',
  GameReferral = 'widget-GameReferral',
  ResetPassword = 'widget-ResetPassword',
  RestorePassword = 'widget-RestorePassword',
  SystemDocContent = 'widget-SystemDocContent',
  ThankYouContent = 'widget-ThankYouContent',
}
